import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import { useTheme } from "../../context/ThemeContext";

function NtDescriptionHightlight({ description, onPress }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const isGateway = description?.match(/\d+,\d+,\d+,\d+/);

  if (isGateway) {
    return (
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <NtTouchableEffect onPress={onPress}>
          <NtText style={styles.highlight}>
            Gateway = {description?.split(",")[0]}
          </NtText>
        </NtTouchableEffect>
        <NtText style={[styles.highlight, { marginLeft: 6 }]}>
          Port = {description?.split(",")[1]}
        </NtText>
      </View>
    );
  }

  return <NtText style={styles.text}>{description}</NtText>;
}

const makeStyles = (t) =>
  StyleSheet.create({
    text: { fontSize: 12, fontWeight: "500", color: t.textDim },
    highlight: {
      backgroundColor: t.surface3,
      borderWidth: 1,
      borderColor: t.borderSoft,
      paddingHorizontal: 7,
      paddingVertical: 2,
      fontSize: 11,
      borderRadius: t.radius,
      color: t.textDim,
      fontWeight: "500",
      overflow: "hidden",
    },
  });

export default NtDescriptionHightlight;
